import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  basicUrl = 'http://localhost:8080/auth';
  basicAuthToken: string = "";

  constructor() {
  }

  /**
   * user passbord token for Basic Login
   * @param username
   * @param password
   */
  buildBasicAuthToken(username: string, password: string) {
    this.basicAuthToken =  btoa(`${username}:${password}`);
  }

}
